import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import alert from "./alert";
import gender from "./gender";
import height from "./height";
import weight from "./weight";
import selectedClothingBrands from "./selectedClothingBrands";
import selectedCarSeatBrands from "./selectedCarSeatBrands";
import showCarSeats from "./showCarSeats";
import showClothingBrands from "./showClothingBrands";

const rootReducer = combineReducers(
  {
    alert,
    gender,
    height,
    selectedClothingBrands,
    selectedCarSeatBrands,
    showCarSeats,
    showClothingBrands,
    weight,
    routing: routerReducer
  }
);

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/